// Fetch refund schedule by permit type
export const FETCH_REFUND_SCHEDULE = 'FETCH_REFUND_SCHEDULE';
export const FETCH_REFUND_SCHEDULE_SUCCESS = 'FETCH_REFUND_SCHEDULE_SUCCESS';
export const FETCH_REFUND_SCHEDULE_FAILURE = 'FETCH_REFUND_SCHEDULE_FAILURE';

// Add refund period
export const ADD_REFUND_PERIOD = 'ADD_REFUND_PERIOD';
export const ADD_REFUND_PERIOD_SUCCESS = 'ADD_REFUND_PERIOD_SUCCESS';
export const ADD_REFUND_PERIOD_FAILURE = 'ADD_REFUND_PERIOD_FAILURE';

// Update refund period
export const UPDATE_REFUND_PERIOD = 'UPDATE_REFUND_PERIOD';
export const UPDATE_REFUND_PERIOD_SUCCESS = 'UPDATE_REFUND_PERIOD_SUCCESS';
export const UPDATE_REFUND_PERIOD_FAILURE = 'UPDATE_REFUND_PERIOD_FAILURE';

// Delete refund period
export const DELETE_REFUND_PERIOD = 'DELETE_REFUND_PERIOD';
export const DELETE_REFUND_PERIOD_SUCCESS = 'DELETE_REFUND_PERIOD_SUCCESS';
export const DELETE_REFUND_PERIOD_FAILURE = 'DELETE_REFUND_PERIOD_FAILURE';

// Update refund schedule header (e.g. UseRelativeDates toggle)
export const UPDATE_REFUND_SCHEDULE = 'UPDATE_REFUND_SCHEDULE';
export const UPDATE_REFUND_SCHEDULE_SUCCESS = 'UPDATE_REFUND_SCHEDULE_SUCCESS';
export const UPDATE_REFUND_SCHEDULE_FAILURE = 'UPDATE_REFUND_SCHEDULE_FAILURE';

// Cancel parking permit
export const CANCEL_PARKING_PERMIT = 'CANCEL_PARKING_PERMIT';
export const CANCEL_PARKING_PERMIT_SUCCESS = 'CANCEL_PARKING_PERMIT_SUCCESS';
export const CANCEL_PARKING_PERMIT_FAILURE = 'CANCEL_PARKING_PERMIT_FAILURE';
